import { Intent, Tag } from '@blueprintjs/core';

export function AITag() {
  return (
    <Tag
      intent={Intent.PRIMARY}
      minimal
      round
      style={{ fontSize: '10px', padding: '0 5px', marginLeft: 4 }}
    >
      IA
    </Tag>
  );
}
